export const API_STATUS = "API_STATUS";
export const ADD_PHASE = "ADD_PHASE";
export const ADD_TABLE = "ADD_TABLE";
export const DELETE_TABLE = "DELETE_TABLE";
export const UPDATE_TABLE = "UPDATE_TABLE";
export const META_LIST = "META_LIST";
export const GET_TABLE = "GET_TABLE";
export const GET_PHASE = "GET_PHASE";
export const DELETE_PHASE = "DELETE_PHASE";
export const GET_PARA = "GET_PARA";
export const ADD_PARA = "ADD_PARA";
export const DELETE_PARA = "DELETE_PARA";
export const UPDATE_PARA = "UPDATE_PARA";
export const REORDER_COLUNM = "REORDER_COLUNM";
export const REORDER_SHEET = "REORDER_SHEET";
export const TEMPLATE_VIEW = "TEMPLATE_VIEW";
export const RESTORE_PARAMETER = "RESTORE_PARAMETER";
export const APPROVE_PARAMETER = "APPROVE_PARAMETER";
export const UPDATE_PHASE = "UPDATE_PHASE";
